import AxiosService from "./AxiosService";

export const updateChatApi = (chat: any) => AxiosService.post("/api/update-chat", chat)